import React from 'react';
import Header from '../../../components/layout/headers/Header';
import DynamicNavigation from "../../../components/layout/navigation/DynamicNavigation";
import TrackLoanApplication from "../components/TrackLoansApplicationProgress";
import { Divider } from 'primereact/divider';
import AppCard from '../../../components/ui/AppCard';
import { Button } from 'primereact/button';
import paymentImage from "../../../assets/images/patterns/loans-bg.png"
import { useHistory } from 'react-router-dom';
// import '../../../assets/styles/auth-tokens.css';
// import '../../../assets/styles/dashboard-theme.css';

const Loans = () => {
    const history = useHistory()
    return (
        <>
            <Header />
            <DynamicNavigation />
            <div className="min-h-screen bg-base-200 pt-28 pb-8">
                <div className="container mx-auto px-4 max-w-7xl">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <div className="flex flex-col">
                            <AppCard headerImg={paymentImage}>
                                <div className="mb-4">
                                    <span className="badge badge-info bg-blue-100 text-blue-700 border-none badge-sm uppercase font-bold mb-3 px-3 py-3 rounded-full tracking-wider text-xs">Loans</span>
                                    <h2 className="text-2xl font-extrabold text-base-content mb-2 tracking-tight">Apply for a new loan</h2>
                                    <p className="text-sm text-base-content/70">Get started on a short term loan tailored to you.</p>
                                </div>
                                <Divider type="solid" className="opacity-30 my-4" />
                                
                                <div className='space-y-4'>
                                    <div>
                                        <Button
                                            onClick={() => { history.push("/loans/new") }}
                                            className="justify-content-center text-center font-bold"
                                            size="large"
                                            label="Apply for loan"
                                            icon="pi pi-plus"
                                            severity="info"
                                            rounded
                                            raised
                                        />
                                    </div>
                                    <div>
                                        <Divider type="solid" className="opacity-30 my-4" />
                                        <p className="text-sm text-base-content/70">We offer the following services: short term loans; foreign exchange services; investments; financial intelligence; financial planning.</p>
                                    </div>
                                </div>
                            </AppCard>
                        </div>
                        <div className="flex flex-col">
                            <TrackLoanApplication />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Loans;
